import React, { useMemo } from "react";

// Floating ember/spark particle field — pure CSS, no JS animation loop.
export default function Embers({ count = 22, className = "" }) {
  const embers = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const left = Math.random() * 100;
        const delay = Math.random() * 12;
        const duration = 10 + Math.random() * 12;
        const size = 3 + Math.random() * 6;
        const drift = (Math.random() * 200 - 100).toFixed(0);
        const opacity = 0.5 + Math.random() * 0.5;
        return { i, left, delay, duration, size, drift, opacity };
      }),
    [count]
  );

  return (
    <div
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      data-testid="embers-field"
      aria-hidden
    >
      {embers.map((e) => (
        <span
          key={e.i}
          className="ember"
          style={{
            left: `${e.left}%`,
            width: `${e.size}px`,
            height: `${e.size}px`,
            animationDelay: `${e.delay}s`,
            animationDuration: `${e.duration}s`,
            opacity: e.opacity,
            "--drift": `${e.drift}px`,
          }}
        />
      ))}
    </div>
  );
}
